import Button from 'react-bootstrap/Button';
import React from 'react';
import { clearMessage } from '../tools/errorhandling';

import {
    triggermails
} from "../dbconnector/connector";

const TriggersCaches = (props) => {

    const  t  = props.translation;
    console.log("in triggersCaches");

    const triggermailsclick = () => {
        triggermails().then(response => {
            if (response.status === 200) {
                console.log("Cache cleared successfully");
            } else {
                console.error("Error clearing cache");
            }
        });
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div id="return" className="form">
                    <h1 className="title">{t('TriggersCaches')}</h1>
                    <Button onClick={triggermailsclick} type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" >trigger rooster mails</Button>
                </div>
            </div>
        </>
    )
}

export default TriggersCaches;